import { observer } from 'mobx-react-lite'
import { SingleItemSelector } from '@/components/SingleItemSelector'
import { Avatar } from '@/components/Avatar'
import { FormGroupContainer } from '@/components/FormContainer'
import { FormRow } from '@/components/Form'
import { AddCustomerToWorkspaceDialog } from '@/features/user-management/AddCustomerToWorkspaceDialog'
import { type AddCustomerToWorkspaceDialogViewModel } from './AddCustomerToWorkspaceDialogViewModel'

export interface AddCustomerToWorkspaceDialogContainerProps {
  vm: AddCustomerToWorkspaceDialogViewModel
}

export const AddCustomerToWorkspaceDialogContainer = observer(
  function AddCustomerToWorkspaceDialogContainer({
    vm,
  }: AddCustomerToWorkspaceDialogContainerProps) {
    return (
      <AddCustomerToWorkspaceDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        onSubmit={vm.submit}
        isSubmitPending={vm.submit.pending}
      >
        <FormRow>
          <FormGroupContainer
            label="Workspace"
            error={vm.validation.getError('workspace')}
          >
            <SingleItemSelector
              value={vm.workspace}
              itemOptions={vm.availableWorkspaces}
              itemPrefix={(item) => (
                <Avatar
                  subject={{
                    avatar: item?.branding.logos.icon,
                  }}
                  size={24}
                />
              )}
              onChange={vm.setWorkspace}
              itemToString={(item) => (item ? item.name : '')}
              placeholder="Select workspace"
              isDisabled={vm.submit.pending}
              testId="add-customer-to-workspace-workspace-selector"
            />
          </FormGroupContainer>
        </FormRow>
      </AddCustomerToWorkspaceDialog>
    )
  },
)
